import { monthNumberToName } from '../utilities/dateUtils.js';

/**
 * Passes through params to equivalent function in utilities/dateUtils.js. Allows us to access the functions from
 * inside vue templates.
 */
export default {
    methods: {
        /**
         * Will return the month name for the given month number.
         * Expects numbers from 1-12, with 1 = Jan, 2 = Feb, etc.
         *
         * @param {number} monthIndex - the integer for the month name to return. Expects numbers from 1-12, with
         *                              1 = Jan, 2 = Feb, etc.
         * @param {string} [format = 'MMMM'] - optional moment month format. The default of 'MMMM' will return the full
         *                                     version of the month name. The next most commonly used will be 'MMM',
         *                                     which will return the shortform version of the month (Jan, Feb, Mar,
         *                                     etc).
         * @returns {string} - the month name
         */
        monthNumberToName(monthIndex, format = 'MMMM') {
            return monthNumberToName(monthIndex, format);
        },
    },
};
